/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './concept-terms.reducer';

export const ConceptTermsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const conceptTermsEntity = useAppSelector(state => state.conceptTerms.entity);
  const loading = useAppSelector(state => state.conceptTerms.loading);
  const updating = useAppSelector(state => state.conceptTerms.updating);
  const updateSuccess = useAppSelector(state => state.conceptTerms.updateSuccess);

  const handleClose = () => {
    navigate(`/concept-terms${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...conceptTermsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...conceptTermsEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.conceptTerms.home.createOrEditLabel" data-cy="ConceptTermsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.conceptTerms.home.createOrEditLabel">Create or edit a ConceptTerms</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="concept-terms-id"
                  label={translate('tinyMedicRestApp.conceptTerms.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.cui')}
                id="concept-terms-cui"
                name="cui"
                data-cy="cui"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.lat')}
                id="concept-terms-lat"
                name="lat"
                data-cy="lat"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.sab')}
                id="concept-terms-sab"
                name="sab"
                data-cy="sab"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.tty')}
                id="concept-terms-tty"
                name="tty"
                data-cy="tty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.str')}
                id="concept-terms-str"
                name="str"
                data-cy="str"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.code')}
                id="concept-terms-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.conceptTerms.sty')}
                id="concept-terms-sty"
                name="sty"
                data-cy="sty"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/concept-terms" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ConceptTermsUpdate;
